import React from 'react';
import {BreadcrumbItem} from "react-bootstrap";
import Page from "../../component/Page/Page";
import EpcDistanceForm from "./EpcDistanceForm";

class EpcDistanceFormPage extends React.Component {
  render() {
    const {match, history} = this.props;
    const breadcrumbs = [
      <BreadcrumbItem key={1} title="Gerar novo EPC para o Mapa"/>];
    return (
        <Page title="Dados do EPC" breadcrumbs={breadcrumbs}>
          <EpcDistanceForm match={match} history={history}/>
        </Page>
    );
  }
}

export default EpcDistanceFormPage;



// WEBPACK FOOTER //
// ./src/map/epc-distance/EpcDistanceFormPage.js